import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";
import * as constants from "../constants";

export function* handleFetchMissingEnrolment({ data }) {
  try {
    const response = yield axios.get(
      `${baseURL}/api/v2/enrolment-history/missing-enrolments`
    );

    const { success } = response.data;
    if (success) {
      yield put(
        actions.fetchMissingEnrolmentSuccess(response.data.data.enrolments)
      );
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchMissingEnrolmentError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* watcherMissingEnrolmentSaga() {
  yield takeLatest(
    constants.FETCH_MISSING_ENROLMENT,
    handleFetchMissingEnrolment
  );
}
